import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7ce894e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-video" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "lp-video__locked"
}
const _hoisted_4 = { class: "lp-video__lock" }
const _hoisted_5 = { class: "lp-item__head" }
const _hoisted_6 = { class: "lp-item__actions" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_9 = { class: "lp-card lp-tabs" }
const _hoisted_10 = {
  class: "lp-tabs__list",
  role: "tablist"
}
const _hoisted_11 = ["aria-selected"]
const _hoisted_12 = ["aria-selected"]
const _hoisted_13 = {
  key: 0,
  class: "lp-tabs__count"
}
const _hoisted_14 = {
  key: 0,
  class: "lp-tabs__panel"
}
const _hoisted_15 = {
  key: 0,
  class: "lp-tabs__description"
}
const _hoisted_16 = {
  key: 1,
  class: "lp-tabs__tags"
}
const _hoisted_17 = {
  key: 1,
  class: "lp-tabs__panel"
}
const _hoisted_18 = {
  key: 0,
  class: "lp-tabs__empty"
}
const _hoisted_19 = {
  key: 2,
  class: "lp-tabs__empty"
}
const _hoisted_20 = {
  key: 1,
  class: "lp-card lesson-loading"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

import { computed, onMounted, ref, toRef, watch } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { hasFeature } from "@/core/helpers/feature";
import HcIcon from "@/modern/components/ui/HcIcon.vue";
import ItemShell from "@/modern/components/training/learningPaths/item/ItemShell.vue";
import ItemKicker from "@/modern/components/training/learningPaths/item/ItemKicker.vue";
import AttachmentList from "@/modern/components/training/learningPaths/item/AttachmentList.vue";
import { usePathwayItemNav } from "@/modern/components/training/learningPaths/item/usePathwayItemNav";
import { IAttachmentItem, lessonMaterialItems } from "@/modern/components/training/learningPaths/item/labs";
import { useLearningPathI18n } from "@/modern/components/training/learningPaths/view/learningPath";


export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    lesson_id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string
  lesson_id: string
}



const store = useStore();
const { lang, tl } = useLearningPathI18n();

const lessonId = toRef(props, "lesson_id");
const nav = usePathwayItemNav(toRef(props, "id"), "lesson", lessonId);

const pathway = computed(() => store.getters.getCurrentPathway);
const lesson = computed(() => store.getters.getLessonData);
const ready = computed(() => lesson.value && String(lesson.value.id) === String(props.lesson_id));
const canWatch = computed(() => hasFeature(lesson.value.feature));

const tab = ref<"about" | "materials">("about");
const toggling = ref(false);

const tags = computed<string[]>(() => (lesson.value.tags || []).map((tag: any) => tag?.name ?? tag).filter(Boolean));

const materials = computed<IAttachmentItem[]>(() => lessonMaterialItems(lesson.value, tl("external_link"), lang.value));

const toggleWatched = async () => {
  if (toggling.value) return;
  toggling.value = true;
  try {
    await store.dispatch(Actions.UPDATE_WATCHED_CHECK, { id: lesson.value.id });
    await store.dispatch(Actions.GET_LESSON, lesson.value.id);
    store.dispatch(Actions.GET_PATHWAY, props.id);
    nav.fetchSections();
  } catch (error) {
    console.error("Error checking the lesson:", error);
  } finally {
    toggling.value = false;
  }
};

onMounted(() => {
  store.dispatch(Actions.GET_LESSON, props.lesson_id);
  store.dispatch(Actions.GET_PATHWAY, props.id);
  nav.fetchSections();
});

watch(lessonId, (value) => {
  tab.value = "about";
  store.dispatch(Actions.GET_LESSON, value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(ItemShell, {
    pathway: _unref(pathway),
    "pathway-id": __props.id,
    "item-title": _unref(ready) ? _unref(lesson).title : '',
    sections: _unref(nav).sections.value,
    current: _unref(nav).current.value,
    prev: _unref(nav).prev.value,
    next: _unref(nav).next.value,
    "href-of": _unref(nav).hrefOf,
    "pathway-href": _unref(nav).pathwayHref.value
  }, {
    default: _withCtx(() => [
      (_unref(ready))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              (_unref(canWatch))
                ? (_openBlock(), _createElementBlock("iframe", {
                    key: 0,
                    src: _unref(lesson).video_url,
                    frameborder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                    allowfullscreen: ""
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, [
                      _createVNode(HcIcon, {
                        name: "lock",
                        size: 26
                      })
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t(`${_unref(lang)}.module.unlock_your_full_potential`)), 1),
                    _createVNode(_component_router_link, {
                      to: { name: 'profile-billing' },
                      class: "lp-btn"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(lang)}.common.subscribe`)) + " ", 1),
                        _createVNode(HcIcon, {
                          name: "arrow",
                          size: 16
                        })
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createVNode(ItemKicker, {
                  kind: "lesson",
                  current: _unref(nav).current.value
                }, null, 8, ["current"]),
                _createElementVNode("h1", null, _toDisplayString(_unref(lesson).title), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["lp-btn", _unref(lesson).is_started ? 'lp-btn--success' : 'lp-btn--outline']),
                  disabled: !_unref(canWatch) || toggling.value,
                  onClick: toggleWatched
                }, [
                  (toggling.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                    : (_openBlock(), _createBlock(HcIcon, {
                        key: 1,
                        name: "check",
                        size: 16
                      })),
                  _createTextVNode(" " + _toDisplayString(_unref(lesson).is_started ? _ctx.$t(`${_unref(lang)}.module.watched_lesson`) : _ctx.$t(`${_unref(lang)}.module.mark_as_watched`)), 1)
                ], 10, _hoisted_7),
                _createElementVNode("button", {
                  type: "button",
                  class: "lp-btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(nav).goNext && _unref(nav).goNext(...args)))
                }, [
                  _createTextVNode(_toDisplayString(_unref(tl)('next')) + " ", 1),
                  _createVNode(HcIcon, {
                    name: "arrow",
                    size: 16
                  })
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  role: "tab",
                  "aria-selected": tab.value === 'about',
                  class: _normalizeClass(["lp-tabs__tab", { 'lp-tabs__tab--active': tab.value === 'about' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'about'))
                }, _toDisplayString(_unref(tl)('about_lesson')), 11, _hoisted_11),
                _createElementVNode("button", {
                  type: "button",
                  role: "tab",
                  "aria-selected": tab.value === 'materials',
                  class: _normalizeClass(["lp-tabs__tab", { 'lp-tabs__tab--active': tab.value === 'materials' }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'materials'))
                }, [
                  _createTextVNode(_toDisplayString(_unref(tl)('materials')) + " ", 1),
                  (_unref(canWatch))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(materials).length), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_12)
              ]),
              (tab.value === 'about')
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_unref(lesson).description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(lesson).description), 1))
                      : _createCommentVNode("", true),
                    (_unref(tags).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tags), (tag) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: tag,
                              class: "lp-tag lp-tag--purple"
                            }, _toDisplayString(tag), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (!_unref(canWatch))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _createVNode(HcIcon, {
                            name: "lock",
                            size: 16
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(lang)}.machine.available_only_for_members`)), 1)
                        ]))
                      : (_unref(materials).length)
                        ? (_openBlock(), _createBlock(AttachmentList, {
                            key: 1,
                            items: _unref(materials)
                          }, null, 8, ["items"]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_unref(tl)('no_materials')), 1))
                  ]))
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
    ]),
    _: 1
  }, 8, ["pathway", "pathway-id", "item-title", "sections", "current", "prev", "next", "href-of", "pathway-href"]))
}
}

})